import { gql } from '@apollo/client';
import { apolloClient } from 'apollo-client';

export const FETCH_CURRENT_LMI_CONTRACT = gql`
  query FetchLmiContractVersion($stateId: Int!, $tag: [ContractTag!]) {
    currentContractVersion(stateId: $stateId, contractType: lmi, tag: $tag) {
      id
      contractId
      displayName
      fileUrl
      contractType
    }
  }
`;

export interface FetchCurrentLmiContractParams {
  stateId: number;
  tag?: string[];
}

export interface ContractVersion {
  id: number;
  contractId: number;
  displayName: string;
  fileUrl: string;
  contractType: string;
}

export const fetchCurrentLmiContract = async (
  params: FetchCurrentLmiContractParams
): Promise<ContractVersion | null> => {
  const { data } = await apolloClient.query({
    query: FETCH_CURRENT_LMI_CONTRACT,
    variables: {
      stateId: params.stateId,
      tag: params.tag || [],
    },
  });

  return data.currentContractVersion || null;
};
